// 【P307】详情页通用字段组 —— 9 类单据共用同一份「凭证/图片/备注/提交时间/提交人/关联财务合同」
//
// 【P307 需求 002】每个详情页都必须有：
//   ① 关联财务合同   → contracts_sn   （展示名由后端 contracts_name 富化）
//   ② 凭证号         → 按单据类型取不同列（见 VOUCHER_PROP）
//   ③ 图片           → attachment_image（无图片时**显示空行**，不隐藏该行）
//   ④ 备注           → remark
//   ⑤ 提交时间       → create_time
//   ⑥ 提交人         → create_user（展示名由后端 create_user_name 富化）
//
// ★ 为什么放在独立文件而不是各单据 js 里各写一份：
//   9 个单据文件改同样的 6 个字段，改 9 遍必然出现遗漏/漂移；
//   这里定义一次，BillList.vue 的 detailGroups 统一 merge 进去。
//
// ★ 「凭证号」各表列名不一致（实测）：
//   t_pro_orders_payment  → number        （用户 10-12 明确：回款凭证号）
//   t_pro_orders_financial_refun → serial_number
//   t_pro_orders_meeting_room    → serial_number
//   t_pro_balance_records / t_pro_invoices / t_pro_contracts → serial_number
//   t_pro_orders_payment_plan（回款计划）→ serial_number
//   统一在 BillList.vue 的 fieldText 里做多列回退，这里只声明 label 与优先级。
export const P307_VOUCHER_LABEL = '凭证号'
export const P307_IMAGE_LABEL = '图片'
export const P307_REMARK_LABEL = '备注'
export const P307_SUBMIT_TIME_LABEL = '提交时间'
export const P307_SUBMIT_USER_LABEL = '提交人'
export const P307_FIN_CONTRACT_LABEL = '关联财务合同'

/** 单据类型 → 凭证号候选列（按优先级，前端逐个回退） */
export const P307_VOUCHER_PROP = {
  // ★ 用户 10-12 明确：t_pro_orders_payment 的 number 就是「回款凭证号」
  payment: ['number', 'serial_number', 'voucher_no'],
  refund: ['serial_number', 'number'],
  room: ['serial_number', 'number'],
  value: ['serial_number', 'number'],
  collection: ['serial_number', 'number'],
  balance: ['serial_number', 'number'],
  financeContract: ['serial_number', 'number'],
  invoice: ['serial_number', 'number'],
  approval: ['serial_number', 'number']
}

/** 单据类型 → 关联财务合同列（回款计划表无 contracts_sn ⇒ 仍渲染，只是空值） */
export const P307_FIN_CONTRACT_PROP = {
  payment: ['contracts_sn', 'contracts_name'],
  refund: ['contracts_sn', 'contracts_name'],
  room: ['contracts_sn', 'contracts_name'],
  value: ['contracts_sn', 'contracts_name'],
  collection: ['contracts_sn', 'contracts_name'],
  balance: ['contracts_sn', 'contracts_name'],
  financeContract: ['sn', 'name'],
  invoice: ['contracts_sn', 'contracts_name'],
  approval: ['contracts_sn', 'contracts_name']
}

/**
 * 生成 P307 六项通用字段（group 名统一为「单据信息」）
 * @param {string} billType 单据类型 key
 * @returns {Array} 可直接塞进 detailGroups 的字段描述
 */
export function p307CommonFields (billType) {
  return [
    {
      key: '__p307_fin_contract',
      label: P307_FIN_CONTRACT_LABEL,
      group: '单据信息',
      p307: 'finContract',
      props: P307_FIN_CONTRACT_PROP[billType] || ['contracts_sn', 'contracts_name']
    },
    {
      key: '__p307_voucher',
      label: P307_VOUCHER_LABEL,
      group: '单据信息',
      p307: 'voucher',
      props: P307_VOUCHER_PROP[billType] || ['serial_number', 'number']
    },
    {
      key: '__p307_image',
      label: P307_IMAGE_LABEL,
      group: '单据信息',
      p307: 'image',
      type: 'upload',
      props: ['attachment_image']
    },
    {
      key: '__p307_remark',
      label: P307_REMARK_LABEL,
      group: '单据信息',
      p307: 'remark',
      props: ['remark', 'search_key', 'content']
    },
    {
      key: '__p307_submit_time',
      label: P307_SUBMIT_TIME_LABEL,
      group: '单据信息',
      p307: 'time',
      type: 'date',
      props: ['create_time']
    },
    {
      key: '__p307_submit_user',
      label: P307_SUBMIT_USER_LABEL,
      group: '单据信息',
      p307: 'user',
      props: ['create_user_name', 'create_user']
    }
  ]
}

export default {
  p307CommonFields,
  P307_VOUCHER_LABEL,
  P307_IMAGE_LABEL,
  P307_REMARK_LABEL,
  P307_SUBMIT_TIME_LABEL,
  P307_SUBMIT_USER_LABEL,
  P307_FIN_CONTRACT_LABEL
}



// WEBPACK FOOTER //
// ./src/pages/contract/p307Common.js